// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2EsPZ","title":"Header_title__9MpDB","side":"Header_side__1ex8z"};